import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/robeyclay',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/robeyclay',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:work@clayroberson.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
